import crud from "./_crud";
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('unit_group', 'el grupo de unidad', 'los ')

const importUnitsGroups = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit_group/import_units_groups`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron los  correctamente.`,
		})
		showSuccessMessage('Se registraron los  correctamente')
		return res.body
	}
}

export default { ...actions, importUnitsGroups }